import React, { useState, useEffect } from 'react';
import { ArrowUpRight } from 'lucide-react';
import Link from 'next/link';

const BlogsSection = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      const fetchBlogs = async () => {
          try {
              const res = await fetch('/projectbim/api/blogs');
              if (res.ok) {
                  const data = await res.json();
                  setBlogs(data.slice(0, 3));
              }
          } catch (err) {
              console.error("Failed to fetch blogs for BlogsSection", err);
          } finally {
              setLoading(false);
          }
      };
      fetchBlogs();
  }, []);

    const getPreviewText = (content) => {
        if (!content) return "";
        try {
            if (content.startsWith('[') || content.startsWith('{')) {
                const blocks = JSON.parse(content);
                return blocks
                    .filter(b => b.type === 'text')
                    .map(b => b.value)
                    .join(' ')
                    .substring(0, 120) + "...";
            }
        } catch (e) {}
        return content.length > 55 ? content.substring(0, 55) + "......." : content;
    };

  const formatDate = (dateString) => {
      if (!dateString) return "Just now";
      return new Date(dateString).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
      });
  };

  const cleanPath = (path) => {
    if (!path) return null;
    if (path.startsWith('data:') || path.startsWith('http')) return path;
    
    // Ensure path starts with a slash
    let finalPath = path.startsWith('/') ? path : '/' + path;
    
    // If it's a relative upload path, route it through the API handler
    if (finalPath.startsWith('/uploads/')) {
        return '/projectbim/api' + finalPath;
    }
    
    // Handle other project-specific paths
    if (!finalPath.startsWith('/projectbim/')) {
        finalPath = '/projectbim' + finalPath;
    }
    
    return finalPath;
  };

  return (
    <section className="blogs-section">
      <div className="blogs-header">
        <div className="blogs-header-left">
          <h2 className="blogs-title">
            <span className="text-primary">Featured</span> Blogs
          </h2>
          <p className="blogs-subtitle">
            Stay ahead of the curve by reading our latest blogs based on real
            <br />
            experience and the latest technology.
          </p>
        </div>
        <Link href="/blog" passHref style={{ textDecoration: 'none' }}>
          <button className="blogs-header-btn">
            View More Blogs <ArrowUpRight size={14} />
          </button>
        </Link>
      </div>

      <div className="blogs-grid">
        {loading ? (
           <div style={{ color: '#54b248', padding: '20px' }}>Loading latest blogs...</div>
        ) : Array.isArray(blogs) && blogs.length > 0 ? (
          blogs
          .filter(blog => blog.status !== 'draft')
          .map((blog) => (
            <Link key={blog.id} href={`/blog/${blog.slug}`} passHref style={{ textDecoration: 'none', display: 'flex', height: '100%' }}>
              <div className="blog-card" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', width: '100%', height: '100%', backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden' }}>
                <div className="blog-card-img" style={{ height: '220px', minHeight: '220px', width: '100%', overflow: 'hidden', backgroundColor: '#eee' }}>
                  <img
                    src={cleanPath(blog.image_url) || 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2831&auto=format&fit=crop'}
                    alt={blog.title}
                    style={{ width: '100%', height: '220px', objectFit: 'cover', display: 'block' }}
                  />
                </div>
                <div className="blog-card-content" style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <p className="blog-date" style={{ fontSize: '13px', color: '#888', margin: 0 }}>{formatDate(blog.created_at)}</p>
                  
                  <h3 style={{ color: 'var(--color-primary)', fontSize: '18px', fontWeight: 'bold', margin: 0, lineHeight: '1.3', display: '-webkit-box', WebkitLineClamp: '1', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {blog.title}
                  </h3>

                  <p className="blog-desc" style={{ color: '#000', fontSize: '16px', fontWeight: 'bold', lineHeight: '1.4', margin: 0, display: '-webkit-box', WebkitLineClamp: '1', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {blog.description || getPreviewText(blog.content)}
                  </p>

                  <div style={{ marginTop: 'auto', paddingTop: '10px', display: 'flex', alignItems: 'center', color: 'var(--color-primary)', fontSize: '14px', fontWeight: 'bold', gap: '5px' }}>
                    Learn More <ArrowUpRight size={14} />
                  </div>
                </div>
              </div>
            </Link>
          ))
        ) : (
           <div style={{ color: '#888', padding: '20px' }}>No blogs published yet.</div>
        )}
      </div>
    </section>
  );
};

export default BlogsSection;
